import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addHomeFailure,
  //
  addHomeSuccess,
  deleteHomeFailure,
  //
  deleteHomeSuccess,
  editHomeFailure,
  //
  editHomeSuccess,
  fetchHomes as fetchHomesAction,
  fetchHomesFailure,
  fetchHomesSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  searchHomeFailure,
  //
  searchHomeSuccess,
} from "./actions";
import {
  ADD_HOME,
  DELETE_HOME,
  EDIT_HOME,
  FETCH_HOMES,
  GET_VIEW_DATA,
  SEARCH_HOME,
} from "./constants";

export function* fetchHomesSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/care-home?${query}`);
    yield put(fetchHomesSuccess(data));
  } catch (e) {
    yield put(fetchHomesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching care home group!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/care-home/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addHomeSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/care-home/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Home added successfully!"));
      yield put(addHomeSuccess());
      if (payload?.history) {
        payload.history.push("/d/home");
      }
    }
  } catch (e) {
    yield put(addHomeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editHomeSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/care-home/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Home updated successfully!"));
      yield put(editHomeSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editHomeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteHomeSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/care-home/${payload}`);
    if (data) {
      yield put(successAlert("Home deleted successfully!"));
      yield put(deleteHomeSuccess());
      yield put(fetchHomesAction());
    }
  } catch (e) {
    yield put(deleteHomeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchHomeSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/care-home?${query}`);
    yield put(searchHomeSuccess(data));
  } catch (e) {
    yield put(searchHomeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while searching home!"));
  }
}

export function* fetchHomesFlow() {
  yield takeEvery(FETCH_HOMES, fetchHomesSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addHomeFlow() {
  yield takeEvery(ADD_HOME, addHomeSaga);
}
export function* editHomeFlow() {
  yield takeEvery(EDIT_HOME, editHomeSaga);
}
export function* deleteHomeFlow() {
  yield takeEvery(DELETE_HOME, deleteHomeSaga);
}
export function* searchHomeFlow() {
  yield takeEvery(SEARCH_HOME, searchHomeSaga);
}
export default function* HomesSaga() {
  yield all([
    fetchHomesFlow(),
    addHomeFlow(),
    editHomeFlow(),
    deleteHomeFlow(),
    getViewDataFlow(),
    searchHomeFlow(),
  ]);
}
